<template>
  <div class="live-upload-page">
    <!-- 我要开播 -->
    <div class="card">
      <h3 class="card-title">我要开播</h3>
      <div class="video-area">
        <div class="video-player">
          <span class="video-tag">未检测到视频信号</span>
          <button class="btn-fill">填入播放地址</button>
        </div>
        <div class="video-ctrl">
          <button class="btn-copy" @click="copyUrl">复制推流地址</button>
          <button class="btn-start" @click="startLive">我要开播</button>
        </div>
      </div>
    </div>

    <!-- 直播间资料 -->
    <div class="card">
      <h3 class="card-title">直播间资料</h3>
      <div class="info-form">
        <!-- 第一行 -->
        <div class="form-col">
          <label>主播昵称</label>
          <input v-model="form.nickname" type="text" />
        </div>
        <div class="form-col">
          <label>直播间名称</label>
          <input v-model="form.roomName" type="text" />
        </div>
        <div class="form-col">
          <label>直播分类</label>
          <div class="custom-select" @click="showCategoryDropdown = !showCategoryDropdown">
            <span class="select-text">{{ form.category ? getCategoryLabel(form.category) : '请选择' }}</span>
            <i class="el-icon-arrow-down"></i>
            <div v-if="showCategoryDropdown" class="dropdown-menu">
              <div
                v-for="item in categoryList"
                :key="item.value"
                class="dropdown-item"
                @click.stop="selectCategory(item.value)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
        <!-- 第二行 -->
        <div class="form-col">
          <label>直播间ID</label>
          <input v-model="form.roomId" type="text" readonly />
        </div>
        <div class="form-col" style="grid-column: span 2;">
          <label>直播间公告</label>
          <input v-model="form.notice" type="text" />
        </div>
      </div>
    </div>

    <!-- 直播间封面 -->
    <div class="card">
      <h3 class="card-title">
        直播间封面
        <span class="tip">请根据直播比例选择图片上传</span>
      </h3>
      <div class="cover-box">
        <div class="upload-frame frame-portrait">
          <button class="btn-upload" @click="uploadV">上传图片</button>
        </div>
        <div class="upload-frame frame-landscape">
          <button class="btn-upload" @click="uploadH">上传图片</button>
        </div>
      </div>
    </div>

    <!-- 提交 -->
    <div class="submit-box">
      <button class="btn-submit" @click="submit">提交资料</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiveUploadPage',
  data() {
    return {
      showCategoryDropdown: false,
      form: {
        nickname: '宁宁',
        roomName: '🎀宁宁的快乐捕捉计划🦄少女广播站',
        category: '',
        roomId: '123455666',
        notice: '友善交流！！'
      },
      categoryList: [
        { label: '音乐', value: 'music' },
        { label: '舞蹈', value: 'dance' },
        { label: '乐器', value: 'instrument' },
        { label: '脱口秀', value: 'talkshow' },
        { label: '二次元', value: 'anime' },
        { label: '颜值', value: 'beauty' },
        { label: '才艺', value: 'talent' },
        { label: '生活方式', value: 'lifestyle' },
        { label: '团舞', value: 'groupdance' },
        { label: '翻唱', value: 'cover' }
      ]
    }
  },
  methods: {
    getCategoryLabel(value) {
      const item = this.categoryList.find(i => i.value === value)
      return item ? item.label : ''
    },
    selectCategory(value) {
      this.form.category = value
      this.showCategoryDropdown = false
    },
    copyUrl() {
      this.$message.success('推流地址已复制')
    },
    startLive() {
      this.$emit('startLive')
    },
    uploadV() {
      this.$emit('uploadV')
    },
    uploadH() {
      this.$emit('uploadH')
    },
    submit() {
      if (!this.form.nickname.trim()) {
        this.$message.error('请输入主播昵称')
        return
      }
      if (!this.form.roomName.trim()) {
        this.$message.error('请输入直播间名称')
        return
      }
      if (!this.form.category) {
        this.$message.error('请选择直播分类')
        return
      }
      this.$message.success('资料提交成功')
    }
  }
}
</script>

<style scoped lang="scss">
.live-upload-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 16px;
}

.card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 12px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;

  .tip {
    font-size: 12px;
    color: #999;
    font-weight: normal;
    margin-left: 8px;
  }
}

// 视频区域
.video-area {
  .video-player {
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #000;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 12px;

    .video-tag {
      padding: 6px 16px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 16px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 12px;
      margin-bottom: 60px;
    }

    .btn-fill {
      position: absolute;
      bottom: 30px;
      padding: 8px 24px;
      background: #4a4a4a;
      border: none;
      border-radius: 16px;
      color: #fff;
      font-size: 13px;
      cursor: pointer;

      &:hover {
        background: #555;
      }
    }
  }

  .video-ctrl {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn-copy {
      padding: 8px 20px;
      background: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 16px;
      color: #666;
      font-size: 13px;
      cursor: pointer;

      &:hover {
        background: #f8f8f8;
      }
    }

    .btn-start {
      padding: 10px 28px;
      background: #8B5CF6;
      border: none;
      border-radius: 20px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}

// 表单 - 网格对齐布局
.info-form {
  display: grid;
  grid-template-columns: 160px 1fr 160px;
  gap: 16px 20px;

  .form-col {
    label {
      display: block;
      font-size: 13px;
      color: #333;
      margin-bottom: 8px;
    }

    input {
      width: 100%;
      padding: 10px 16px;
      border: 1px solid #e8e8e8;
      border-radius: 20px;
      font-size: 14px;
      color: #333;
      background: #fafafa;
      outline: none;
      box-sizing: border-box;

      &:focus {
        border-color: #8B5CF6;
      }

      &[readonly] {
        background: #f5f5f5;
        color: #999;
      }
    }

    // 自定义下拉框
    .custom-select {
      position: relative;
      width: 100%;
      padding: 10px 16px;
      border: 1px solid #e8e8e8;
      border-radius: 20px;
      font-size: 14px;
      color: #333;
      background: #fafafa;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;

      .select-text {
        color: #333;
      }

      .el-icon-arrow-down {
        color: #999;
        font-size: 12px;
      }

      .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 4px;
        background: #fff;
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        z-index: 100;
        max-height: 200px;
        overflow-y: auto;

        .dropdown-item {
          padding: 10px 16px;
          font-size: 14px;
          color: #333;
          cursor: pointer;
          transition: background 0.2s ease;

          &:hover {
            background: #f5f5f5;
          }

          &:first-child {
            border-radius: 8px 8px 0 0;
          }

          &:last-child {
            border-radius: 0 0 8px 8px;
          }
        }
      }
    }

    // 直播间公告占两列
    &:nth-child(5) {
      grid-column: span 2;
    }
  }
}

// 封面区域 - 淡紫色背景
.cover-box {
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 40px 60px;
  display: flex;
  gap: 60px;
  justify-content: center;
  align-items: center;
  background: #e8ecff;

  .upload-frame {
    border: 1px solid #d0d8ff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f2ff;

    &.frame-portrait {
      width: 200px;
      height: 300px;
    }

    &.frame-landscape {
      width: 360px;
      height: 200px;
    }

    .btn-upload {
      padding: 10px 40px;
      background: #9ca3af;
      border: none;
      border-radius: 20px;
      color: #fff;
      font-size: 13px;
      cursor: pointer;

      &:hover {
        background: #6b7280;
      }
    }
  }
}

// 提交
.submit-box {
  display: flex;
  justify-content: center;
  padding: 8px 0;

  .btn-submit {
    padding: 10px 40px;
    background: #8B5CF6;
    border: none;
    border-radius: 20px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>